(() => {
  // Yotpo passes an absolute return_to URL, which Shopify rejects.
  const selector = '.yotpo-drawer-sign-in-link, .yotpo-drawer-sign-up-item';

  const openLogin = (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest(selector);
    if (!button || !button.closest('.yotpo-drawer-layout')) return;
    if (event.type === 'click' && event.button !== 0) return;
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;

    const returnTo = new URL(window.location.href);
    returnTo.searchParams.delete('preview_theme_id');
    const login = new URL('/customer_authentication/login', window.location.origin);
    login.searchParams.set('return_to', returnTo.pathname + returnTo.search);

    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(login.pathname + login.search);
  };

  document.addEventListener('click', openLogin, true);
  document.addEventListener('keydown', openLogin, true);
})();
